module.exports = __webpack_public_path__ + "static/media/Qmerit-logo.aaa3891d.svg";